import React from "react";
import { Typography } from "antd";

const { Title } = Typography;

const UIHeading = ({ children, bold, type, level, className, style, ellipsis, font, color  }) => {
  return (
    <Title
      type={type}
      style={{ margin: 0, color: color, fontFamily: (!font ? bold ? "MontserratSemiBold" : "Montserrat" : font) + ", sans- serif", ...style }}
      level={level}
      className={className}
      ellipsis={ellipsis}
    >
      {children}
    </Title >
  );
};

export default UIHeading;
